import { cn } from '@tripleten/cn';

export const cnPageInternalUpdatePassword = cn('page-internal-update-password');
